import { UseQueryOptions } from 'react-query';
import useQuery from 'hooks/useQuery';
import QueryKeys from 'hooks/queries/keys';

type Params = {
    path: string;
    reactQueryOptions?: UseQueryOptions<string[], Error>;
    sendId: number;
};

const useGetSendInteractions = (params: Params) => {
    const { path, reactQueryOptions, sendId } = params;
    const queryKey = QueryKeys.SEND_ID_CLICKABLE_URLS(sendId);

    const pathWithSendId = path?.replace(':sendId', sendId?.toString());

    // Disable the query if path is undefined/empty
    const finalQueryOptions = {
        ...reactQueryOptions,
        enabled: Boolean(pathWithSendId) && (reactQueryOptions?.enabled ?? true),
    };
    // Use a dummy path when disabled to prevent undefined from reaching useQuery
    return useQuery(queryKey, pathWithSendId || 'dummy-disabled-path', finalQueryOptions);
};

export default useGetSendInteractions;
